import React from "react";
import Logo from "../assets/logo.svg";
import { motion } from "framer-motion";
import {
  RiFacebookFill,
  RiTwitterFill,
  RiGithubFill,
  RiLinkedinFill,
  RiBehanceFill,
} from "@remixicon/react";

const Footer = () => {
  const footerAnimation = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        staggerChildren: 0.1,
      },
    },
  };

  const itemAnimation = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: "easeOut",
      },
    },
  };

  const socialIconVariants = {
    hidden: { opacity: 0, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.3,
        ease: "circOut",
      },
    },
    hover: {
      scale: 1.1,
      backgroundColor: "#2563eb",
      transition: {
        duration: 0.2,
        ease: "easeInOut",
      },
    },
    tap: {
      scale: 0.95,
    },
  };

  const socialLinks = [
    {
      icon: <RiGithubFill />,
      href: "https://github.com/Abdalbaset11",
      label: "GitHub",
    },
    {
      icon: <RiTwitterFill />,
      href: "https://x.com/Abdalbaset38",
      label: "Twitter",
    },
    {
      icon: <RiLinkedinFill />,
      href: "https://www.linkedin.com/in/abdalabset-ibrahem-4254922a6/",
      label: "LinkedIn",
    },
    {
      icon: <RiBehanceFill />,
      href: "https://www.behance.net/AbdalbasetI38",
      label: "Behance",
    },
  ];

  return (
    <motion.section
      className="h-screen flex flex-col justify-between items-center pt-24"
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.3 }}
      variants={footerAnimation}
    >
      <div className="container m-auto px-4 md:px-0">
        <motion.div
          className="flex flex-col gap-8 items-center"
          variants={itemAnimation}
        >
          <motion.div
            className="flex flex-col gap-2 items-center"
            variants={itemAnimation}
          >
            <motion.img
              src={Logo}
              alt="Logo"
              width={"24px"}
              variants={itemAnimation}
              whileHover={{ rotate: 180, transition: { duration: 0.3 } }}
            />
            <motion.h2
              className="text-2xl md:text-4xl font-semibold"
              variants={itemAnimation}
            >
              SAY HELLO
            </motion.h2>
          </motion.div>
          <motion.div
            className="flex flex-col gap-6 items-center"
            variants={itemAnimation}
          >
            <motion.a
              href="mailto:abdalbaset.ibrahem11@gmail.com"
              className="text-lg md:text-2xl hover:text-primary_700 transition-colors"
              variants={itemAnimation}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              abdalbaset.ibrahem11@gmail.com
            </motion.a>
            <motion.a
              href="https://wa.me/+249992333432"  
              className="text-lg md:text-2xl hover:text-primary_700 transition-colors"
              variants={itemAnimation}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              wa.me/Abdalbaset38
            </motion.a>
          </motion.div>
          <motion.div
            className="flex gap-6"
            variants={itemAnimation}
          >
            {socialLinks.map((social, index) => (
              <motion.a
                key={index}
                href={social.href}
                className="p-2 border-2 border-white rounded-full"
                variants={socialIconVariants}
                whileHover="hover"
                whileTap="tap"
                aria-label={social.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="w-6 h-6">{social.icon}</div>
              </motion.a>
            ))}
          </motion.div>
        </motion.div>
      </div>
      <motion.div
        className="border-white border-opacity-10 border-t-2 border-cardPackground py-9 w-full text-center"
        variants={itemAnimation}
      >
        <motion.p
          className="px-10 md:px-0 text-sm md:text-base"
          variants={itemAnimation}
          whileHover={{ scale: 1.05 }}
        >
          Developed and designed @ Abdalbaset Ibrahem
        </motion.p>
      </motion.div>
    </motion.section>
  );
};

export default Footer;
